import { render, staticRenderFns } from "./print-pdf-item.vue?vue&type=template&id=60abb591&scoped=true&"
import script from "./print-pdf-item.vue?vue&type=script&lang=js&"
export * from "./print-pdf-item.vue?vue&type=script&lang=js&"
import style0 from "./print-pdf-item.vue?vue&type=style&index=0&id=60abb591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60abb591",
  null
  
)

/* custom blocks */
import block0 from "./locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fgitlab-runner%2Fbuilds%2F7624f89f%2F0%2Ftokyo-auction%2Ftokyo-auction-frontend%2Fsrc%2Fcomponents%2Fauction%2Fprint-pdf-item.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports